import { getShortOperation } from '@helpers/helper.properties'
import { ElementHTML } from '@helpers/helper.rendering'
import useQueryProperties from '@hooks/useQueryProperties'
import useQueryProperty from '@hooks/useQueryProperty'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Property, RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'

const BD_Properties_Similar_1 = ({
  global_data,
  title,
  titleHexa,
  titleElement,
  propertyID,
  backgroundColor,
}: RealEstateDataPageComponentData & { propertyID: string }) => {
  const { filters, offset, orders, coordinates, polygonCoordinates, viewId }: StatePropertiesSlice =
    useSelector((state: { properties: StatePropertiesSlice }) => state.properties)

  const API_KEY = global_data.pageConfig.keys.tokko

  const { data } = useQueryProperty(propertyID, API_KEY)

  const similar = {
    ...filters,
    operation: data?.operations
      ? getShortOperation(data?.operations[0].operation_type.toLowerCase())
      : 'venta',
  }

  const propCard = global_data?.content?.cardsProperties?.type_id || '1'

  const Card = require(`@components/cardsProperties/${propCard}`)?.default

  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters: similar,
    coordinates: [],
    polygonCoordinates: [],
    orders,
    offset,
    tokkoKey: API_KEY,
  })

  const getSimilarProperties = () => {
    if (properties?.objects) {
      let props: any = properties?.objects?.filter((prop: Property) => prop.id != data?.id)
      const byLocation = props?.filter(
        (prop: Property) => prop.location.name == data?.location.name,
      )
      const ranking = calcularRankingCoincidencias(
        data,
        props?.filter((prop: Property) => prop.location.name != data?.location.name),
        'id',
      )
      return [...byLocation, ...ranking]
    }
    return []
  }

  function calcularRankingCoincidencias(
    property: Property,
    properties: Property[] | undefined,
    key: string,
  ) {
    if (!property?.tags || !properties?.length) {
      return []
    }

    // Crear un Set con los valores de la clave de los tags del property base.
    const baseTagsSet = new Set(property?.tags.map((tag: any) => tag[key]))

    // Calcular coincidencias y porcentaje para cada property.
    const resultados = properties.map((otraPropiedad) => {
      if (!otraPropiedad.tags) {
        return { ...otraPropiedad, porcentajeCoincidencia: 0 }
      }

      const coincidencias = otraPropiedad.tags.filter((tag: any) =>
        baseTagsSet.has(tag[key]),
      ).length
      const porcentaje = (coincidencias / property.tags.length) * 100

      return {
        ...otraPropiedad,
        porcentajeCoincidencia: porcentaje.toFixed(2), // Redondear a 2 decimales
      }
    })

    // Ordenar por porcentaje de coincidencia descendente.
    //@ts-ignore
    resultados.sort((a, b) => b.porcentajeCoincidencia - a.porcentajeCoincidencia)

    return resultados
  }

  return (
    <section
      style={{
        background: backgroundColor ? backgroundColor : 'var(--backgroundColor)',
        zIndex: 9,
      }}
      className="p-y-config similar-properties position-relative a"
    >
      <Container fluid>
        <Row>
          <Col lg={12}>
            <ElementHTML
              children={title}
              elementType={titleElement || 'h2'}
              className="mb-4 mb-lg-5"
              style={{ color: titleHexa || '1f1f1f' }}
            />
          </Col>
          {getSimilarProperties()
            .slice(0, 3)
            .map((prop, index) => (
              <Col
                key={index}
                lg={4}
              >
                <Card
                  property={prop}
                  global_data={global_data}
                />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  )
}

export default BD_Properties_Similar_1
